import { get, post, put } from "../utils/apiHelper"


export const createRoom = (data) =>{
    return post('/room/create',data)
}

export const getRoomsByVenueId = (venueId) =>{
    const params = { venueId }
    return get(`/room/list`,{ params })
}

export const updateRoom =({id, data}) =>{
    return put(`/room/update/${id}`,data)
}
export const getRoomById =(id) =>{
    return get(`/room/fetch/${id}`)
}

export const deleteRoom = (roomId) =>{
    return put(`/room/delete/${roomId}`,{  })
}

export const createRoomEvent = (data) =>{
    return post('/room/event',data)
    
}
export const getRoomEvents = (roomId) =>{
    const params = { currentDate:new Date() }
    return get(`/room/eventsByRoomId/${roomId}`, {params})
}

export const updateEvent =({id, data}) =>{    
    return put(`/room/update/event/${id}`,data)
}

export const getUpcomingEvents = () =>{
    const params = { currentDate:new Date() }
    return get(`/room/events/upcoming`,{ params })
}
/**USER APIS HERE BELOW */

export const getRoomSession = (id)=>{
    return post(`/room/room-details/${id}`,{currentDate:new Date()});
}

export const getVenueRoom = (id)=>{
    return post(`/room/room-details-by-id/${id}`,{currentDate:new Date()});
}
export const getRoomSessionByName = (name)=>{
    return post(`/room/room-details-by-name/${name}`,{currentDate:new Date()});
}

export const updateZoomEvent = (id,body)=>{
    return put(`/room/update-zoom-event/${id}`,body);
}
//Admin side apis 
export const getEventDetails = (eventId)=>{
   return get(`/room/event-details/${eventId}`);
}
//Admin side apis 
export const getEventById = (eventId)=>{
    console.log('The room Id',eventId)
    return get(`/room/event-by-id/${eventId}`);
 }

 export const updateTableDetails = (body)=>{
   return post(`/room/update-table-details`,body)
 }

 export const getTableSignature = (tableId)=>{
     return post('/room/get-table-signature',{tableId,tableId})
 }
//this is only used to update the table members 
 export const updateTable = (tableId,members)=>{
     return post('/room/update-table',{tableId,members});

 }

export const getMessages = ({roomId,venueId,eventId,tableId, chatType, skip, limit}) =>{
    const params = { skip, limit, venueId, chatType,roomId,eventId,tableId }
    return get(`/room/messages`,{params})
}

export const getRoomTable = (id)=>{
    return get(`/room/roomTable/${id}`);
}

export const getHomeLayout = (id)=>{
   return get(`/room/homeLayout/${id}`)
}

export const updateEventHomeLayout = (eventId,body)=>{
    return put(`/room/update-event-homeLayout/${eventId}`,{homeLayout:body});
}
export const alluserchat=(senderId,receiverId)=>{
    return get(`/user/alluserchat/${senderId}/${receiverId}`)
}